import { ReactNode } from 'react';
import { FinanceNav } from './FinanceNav';

interface FinancePageLayoutProps {
  children: ReactNode;
}

/**
 * Wrapper padronizado para todas as páginas do módulo Finance.
 * Garante padding, max-width e espaçamento consistente.
 */
export function FinancePageLayout({ children }: FinancePageLayoutProps) {
  return (
    <div className="p-6 md:p-8">
      <div className="max-w-7xl mx-auto space-y-6">
        <FinanceNav />
        {children}
      </div>
    </div>
  );
}
